
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 53 53","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M9.99 52.45H.46V37.56h9.53zm-7-2.5h4.47v-9.86h-4.5zM24.17 52.45h-9.52V28.98h9.52zm-7-2.5h4.52V31.48h-4.54zM38.36 52.45h-9.53V39.84h9.53zm-7-2.5h4.5v-7.61h-4.53zM52.54 52.45h-9.52V22.87h9.52zm-7-2.5h4.52V25.37h-4.54z"}}),_c('path',{staticClass:"icon-fill arrow",attrs:{"fill":"#5ebca8","d":"M31.15 8.75l1.76 1.77-8.4 8.41-5.82-5.83 1.76-1.76 4.06 4.05z"}}),_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M38.21 25.37h-12.4a12.41 12.41 0 1112.4-12.41zM25.81 3.06a9.91 9.91 0 100 19.81h9.9v-9.91a9.91 9.91 0 00-9.9-9.9z"}})])
          )
        }
      }
    